export const environment = {
  production: false,
  environment: 'UAT',
  socketBase: 'http://hermes.stage-ws.horseracing.software/cos',
  apiBase: 'https://api10.horseracing.software',
  authUrl: 'https://auth.horseracing.software',
  silkBase: `http://draper.stage.horseracing.software/silks`,
  tenantId: 'a82d94ad-6cee-4fa8-8b1f-63a0eef96cec',
  weatherbys: (isWeatherbys)()
};

function isWeatherbys(): Boolean {
  let isWeatherbys = false;
  if (window.location.hostname.indexOf('wby') !== -1) {
    isWeatherbys = true;
  }
  return isWeatherbys;
}
